import { CMSResource } from "app/resources/cmsresource";
import { FooterResource } from "./FooterResource";

export class FooterUsefulContactsResource extends CMSResource {

	rid: number;
	titleRo: string;
	titleFr: string;
	titleEn: string;
	titleDe: string;
	contact: string;
	orderIndex: number;
	footerResource: FooterResource;
	showDelete: boolean = false;
}
